import { Face } from '@/assets/images';
import type { IAvatarAccessory } from '../types';

export const FACE: IAvatarAccessory[] = [
  {
    id: 'F001',
    available: true,
    colorPicker: true,
    name: 'Face_Homeless',
    icon: <img src={Face.Face1} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F002',
    available: true,
    colorPicker: true,
    name: 'Face_Stars',
    icon: <img src={Face.Face2} />,
    colors: ['#DB0C67', '#DB0007', '#FFBC0D', '#33BFD2']
  },
  {
    id: 'F003',
    available: true,
    colorPicker: true,
    name: 'Face_Gotee',
    icon: <img src={Face.Face3} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F004',
    available: true,
    colorPicker: true,
    name: 'Face_Trimmed',
    icon: <img src={Face.Face4} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F005',
    available: true,
    colorPicker: true,
    name: 'Face_Crook',
    icon: <img src={Face.Face5} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F006',
    available: true,
    colorPicker: true,
    name: 'Face_VR',
    icon: <img src={Face.Face6} />,
    colors: ['#DB0007', '#FFBC0D', '#33BFD2', '#E97B98']
  },
  {
    id: 'F007',
    available: true,
    colorPicker: true,
    name: 'Face_Cat',
    icon: <img src={Face.Face7} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F008',
    available: true,
    colorPicker: true,
    name: 'Face_Pirate',
    icon: <img src={Face.Face8} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F009',
    available: true,
    colorPicker: true,
    name: 'Face_Dolly',
    icon: <img src={Face.Face9} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F010',
    available: true,
    colorPicker: true,
    name: 'Face_Cool',
    icon: <img src={Face.Face10} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F011',
    available: true,
    colorPicker: true,
    name: 'Face_Chef',
    icon: <img src={Face.Face11} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F012',
    available: true,
    colorPicker: true,
    name: 'Face_Wolf',
    icon: <img src={Face.Face12} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F013',
    available: true,
    colorPicker: true,
    name: 'Face_Tired',
    icon: <img src={Face.Face13} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F014',
    available: true,
    colorPicker: true,
    name: 'Face_Serious',
    icon: <img src={Face.Face14} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F015',
    available: true,
    colorPicker: true,
    name: 'Face_Loweffort',
    icon: <img src={Face.Face15} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F016',
    available: true,
    colorPicker: true,
    name: 'Face_Supercute',
    icon: <img src={Face.Face16} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F017',
    available: true,
    colorPicker: true,
    name: 'Face_Cute',
    icon: <img src={Face.Face17} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F018',
    available: false,
    colorPicker: true,
    name: 'Face_MLK',
    icon: <img src={Face.Face18} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F019',
    available: false,
    colorPicker: true,
    name: 'Face_Frida',
    icon: <img src={Face.Face19} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F020',
    available: true,
    colorPicker: true,
    name: 'Face_Normal',
    icon: <img src={Face.Face20} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F021',
    available: false,
    colorPicker: true,
    name: 'Face_Einstein',
    icon: <img src={Face.Face21} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'F022',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows1',
    icon: <img src={Face.Face22} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F023',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows2',
    icon: <img src={Face.Face23} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F024',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows3',
    icon: <img src={Face.Face24} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F025',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows4',
    icon: <img src={Face.Face25} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F026',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows5',
    icon: <img src={Face.Face26} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F027',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows6',
    icon: <img src={Face.Face27} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F028',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows7',
    icon: <img src={Face.Face28} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F029',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows8',
    icon: <img src={Face.Face29} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F030',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows9',
    icon: <img src={Face.Face30} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F031',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows10',
    icon: <img src={Face.Face31} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F032',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows11',
    icon: <img src={Face.Face32} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F033',
    available: true,
    colorPicker: true,
    name: 'X_Face_Eyebrows12',
    icon: <img src={Face.Face33} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F034',
    available: true,
    colorPicker: true,
    name: 'X_Face_Glasses1',
    icon: <img src={Face.Face34} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F035',
    available: true,
    colorPicker: true,
    name: 'X_Face_Glasses2',
    icon: <img src={Face.Face35} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F036',
    available: true,
    colorPicker: true,
    name: 'X_Face_Glasses3',
    icon: <img src={Face.Face36} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F037',
    available: true,
    colorPicker: true,
    name: 'X_Face_Glasses4',
    icon: <img src={Face.Face37} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F038',
    available: true,
    colorPicker: true,
    name: 'X_Face_Glasses5',
    icon: <img src={Face.Face38} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F039',
    available: true,
    colorPicker: true,
    name: 'X_Face_Glasses6',
    icon: <img src={Face.Face39} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F040',
    available: true,
    colorPicker: true,
    name: 'X_Face_Glasses7',
    icon: <img src={Face.Face40} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  },
  {
    id: 'F041',
    available: true,
    colorPicker: true,
    name: 'X_Face_Glasses8',
    icon: <img src={Face.Face41} />,
    colors: ['#8C4900', '#151515', '#F4DDAA', '#FFFFFF']
  }
];
